import { NavigateOptions } from 'react-router/dist/lib/context';
import { ReactNode } from 'react';
import { ButtonProps } from '../../button/Button';
import { ConfirmModalProps } from '../../modal/ConfirmModal/ConfirmModal';
import { GenericApiResponse } from '../../shared/interfaces/generics';
import { TrackingEvent } from '../../tracking/trackers/tracker';
import { IconButtonExtendedProps } from '../../button/IconButton/IconButton';
import { LinkProps } from '../../link/LinkButton';

export enum EntityActionType {
  INLINE = 'INLINE',
  MENU = 'MENU',
  INLINE_ICON = 'INLINE_ICON',
  INLINE_LINK = 'INLINE_LINK'
}

export enum EntityActionHandlerType {
  CONFIRM = 'CONFIRM',
  NAVIGATE = 'NAVIGATE',
  CUSTOM = 'CUSTOM'
}

export interface EntityRawAction<T> {
  type: T;
  display_name: string;
  description?: string;
  is_disabled?: boolean;
  disabled_reason?: string;
}

export interface EntityAction<T> {
  action: T;
  type: EntityActionType;
  actionHandlerType: EntityActionHandlerType;
  displayName: string;
  description?: string;
  icon?: string;
  iconClass?: string;
  iconSize?: number;
  disabled?: boolean;
  disabledReason?: string;
  inlineOptions?: Partial<ButtonProps>;
  inlineIconOptions?: Partial<IconButtonExtendedProps>;
  inlineLinkOptions?: Partial<LinkProps>;
  routeOptions?: {
    route: string;
    options?: NavigateOptions;
  };
  className?: string;
  onClick?: () => void;
  CustomAction?: ReactNode;
  trackingProps?: TrackingEvent;
}

export type EntityActionConfirmDialogPropsValue<E> = Partial<
  ConfirmModalProps<object, object> & {
    actionHandler: (args: {
      entity: E;
      signal: AbortSignal;
      [key: string]: unknown;
    }) => Promise<GenericApiResponse<unknown>>;
    successMessage: string;
  } & {
    postConfirmationDialogProps?: Partial<ConfirmModalProps<object, object>>;
  }
>;

export type EntityActionConfirmDialogProps<A extends string | number | symbol, E> = Record<
  A,
  EntityActionConfirmDialogPropsValue<E>
>;
